/** 鲸吞加微调用接口域名（流程设置 · 调用接口） */
export const WECHAT_FLOW_TASK_HOSTS = Object.freeze([
  'newrobot-api.gooki.com',
  'newrobot-api.zhizeliming.cn',
  'newrobot-api.zhizeliming.com',
])

const WECHAT_FLOW_TASK_PATH = '/bilnil/wx/add'

export function isWechatFlowTaskApiUrl(url) {
  const raw = String(url != null ? url : '').trim()
  if (!raw) return false
  try {
    const parsed = new URL(raw)
    const host = String(parsed.hostname || '').toLowerCase()
    if (!WECHAT_FLOW_TASK_HOSTS.includes(host)) return false
    return String(parsed.pathname || '').includes(WECHAT_FLOW_TASK_PATH)
  } catch (e) {
    const lower = raw.toLowerCase()
    return (
      WECHAT_FLOW_TASK_HOSTS.some((host) => lower.includes(host)) &&
      raw.includes(WECHAT_FLOW_TASK_PATH)
    )
  }
}

/** 从调用接口「接口内容」中提取 virTaskId */
export function extractVirTaskIdFromApiContent(content) {
  const raw = String(content != null ? content : '').trim()
  if (!raw) return ''

  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      const val = parsed.virTaskId != null ? parsed.virTaskId : parsed.virtaskid
      if (val != null && String(val).trim() !== '') return String(val).trim()
    }
  } catch (e) {
    // 内容不一定是严格 JSON，走正则
  }

  const match = raw.match(/["']?virTaskId["']?\s*[:=]\s*["']?([^"'\s,}]+)/i)
  return match && match[1] ? String(match[1]).trim() : ''
}

export function collectWechatFlowTaskIds(apiSettings) {
  const src = apiSettings && typeof apiSettings === 'object' ? apiSettings : {}
  const ids = []
  Object.keys(src).forEach((key) => {
    const item = src[key]
    if (!item || typeof item !== 'object') return
    if (item.type) return
    if (!isWechatFlowTaskApiUrl(item.url)) return
    ids.push(extractVirTaskIdFromApiContent(item.content))
  })
  return [...new Set(ids)]
}
